import { render, staticRenderFns } from "./PostBox.vue?vue&type=template&id=6a47bec9"
import script from "./PostBox.vue?vue&type=script&lang=js"
export * from "./PostBox.vue?vue&type=script&lang=js"
import style0 from "./PostBox.vue?vue&type=style&index=0&id=6a47bec9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports